import { render, staticRenderFns } from "./HistoryPreview.vue?vue&type=template&id=0900d307&"
import script from "./HistoryPreview.vue?vue&type=script&lang=js&"
export * from "./HistoryPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports